import React, { useState } from "react";
import Head from "next/head";
import { useTranslation } from "next-i18next";
import { TopbarLanding } from "../../../components/LandingPage/topbar";
import { Footer } from "../../../components/LandingPage/footer";
import { getI18nProps, getStaticPaths } from "../../../lib/next-i18next/getStatic";
import { FaceLiftGlobalStyle } from "../../../styles/theme";
import DefaultDarkModeHOC from "../../../components/theme/DefaultDarkModeHOC";
import NDAForm from "../../../components/NDAForm";

const NDAPageMeta = () => {
	const { t } = useTranslation();

	return (
		<Head>
			<title>{t("nda.meta.title")}</title>
			<meta name="title" content={t("nda.meta.title")} />
			<meta name="description" content={t("nda.meta.description")} />
			<meta name="robots" content="noindex, nofollow" />
		</Head>
	);
};

const NDAPage = ({ _nextI18Next, locale }) => {
	const [mounted, setMounted] = useState(false);

	React.useEffect(() => {
		setMounted(true);
	}, []);

	return (
		<DefaultDarkModeHOC>
			<NDAPageMeta />
			<FaceLiftGlobalStyle />
			<TopbarLanding />
			{mounted && <NDAForm />}
			<Footer />
		</DefaultDarkModeHOC>
	);
};

export const getStaticProps = async (ctx) => {
	const i18nProps = await getI18nProps(ctx);

	return {
		props: {
			...i18nProps,
			locale: i18nProps._nextI18Next.initialLocale,
		},
	};
};

export { getStaticPaths };

export default NDAPage;
